import { useCallback, useEffect, useState } from 'react';
import {
  getAllOfficers,
  updateOfficerRole,
  updateOfficerStatus,
  deleteOfficer,
} from '../services/officersService';

export function useOfficers() {
  const [officers, setOfficers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refetch = useCallback(() => {
    setLoading(true);
    return getAllOfficers()
      .then((data) => {
        setOfficers(data);
        setError('');
      })
      .catch((err) => setError(err.message || 'Failed to load users'))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const updateRole = useCallback(
    async (authId, role) => {
      await updateOfficerRole(authId, role);
      await refetch();
    },
    [refetch]
  );

  const updateStatus = useCallback(
    async (authId, status) => {
      await updateOfficerStatus(authId, status);
      await refetch();
    },
    [refetch]
  );

  const remove = useCallback(
    async (authId) => {
      await deleteOfficer(authId);
      await refetch();
    },
    [refetch]
  );

  return { officers, loading, error, updateRole, updateStatus, remove };
}
